import React from "react";
import { Props as TagsProps } from "src/components/Tags/TagsList";
import { TagsPopover } from "src/components/Tags/TagsPopover";
import { sleep } from "src/services/sleep";
import * as RemoteData from "src/types/remoteData";
import { useBulkActionTags } from "./useBulkActionTags";

type Props = {
  enrollmentPeriodId: uuid;
} & Omit<TagsProps, "tags" | "onSearch" | "onTagUpdate">;

export const BulkTagsPopoverAsync: React.FC<Props> = ({
  enrollmentPeriodId,
  ...overrideTagsProps
}) => {
  const {
    setSelectedRows,
    tagsProps,
    resetTags,
    setSelectedTagGroupId,
    tagGroups,
    confirmationDialog,
    loadTargets,
  } = useBulkActionTags({ enrollmentPeriodId });

  const onOpen = React.useCallback(async () => {
    setSelectedRows(RemoteData.loading());

    await sleep(100);
    try {
      const ids = await loadTargets();
      setSelectedRows(RemoteData.success(ids));
    } catch (error) {
      setSelectedRows(
        RemoteData.failure(
          error instanceof Error ? error : new Error("Failed to load selection")
        )
      );
    }
  }, [loadTargets, setSelectedRows]);

  return (
    <>
      <TagsPopover
        onOpen={onOpen}
        buttonProps={{ variant: "banner", size: "sm" }}
        onSelectTagGroup={setSelectedTagGroupId}
        isBulkAction={true}
        tagGroups={tagGroups}
        onBackClick={() => resetTags(true)}
        {...tagsProps}
        {...overrideTagsProps}
      />
      {confirmationDialog}
    </>
  );
};
